import React, { Component } from 'react'
import styled from 'styled-components'
import './App.css'
import store from './redux/store'
import { Provider as ReduxProvider } from 'react-redux'
import ViewsManager from './views/ViewsManager'
import appActions from './redux/actions/appActions'
import { parse } from 'qs'

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	margin: auto;
	overflow: hidden;
`

class App extends Component {
	componentDidCatch(error: any) {
		store.dispatch(appActions.errorCaught(error))
	}

	handleWindowResize = () => {
		const windowW = window.innerWidth
		const windowH = window.innerHeight
		store.dispatch(appActions.windowResized(windowW, windowH))
	}

	componentDidMount() {
		this.handleWindowResize()
		setTimeout(this.handleWindowResize, 1000)
		window.addEventListener('resize', this.handleWindowResize)
		const params = parse(window.location.search.substr(1))
		const gameSessionUid = window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1)
		params.gameSessionUid = gameSessionUid
		store.dispatch(appActions.initializeApp(params))
	}

	render() {
		return (
			<ReduxProvider store={store}>
				<Wrapper>
					<ViewsManager />
				</Wrapper>
			</ReduxProvider>
		)
	}
}

export default App
